import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
// component imports
import { StatsSection } from '../../../statspro/js/components/common/stats-section';
import { SeasonNavItem } from './nav-items/SeasonNavItem';
import { CompNavItem } from './nav-items/CompNavItem';
import { RoundListNavItem } from './nav-items/RoundListNavItem';
//store imports
import { navSelector } from '../../../store/js/modules/video-hub/nav/selectors/nav-selector';
import { useCompetitionNavigationOptions } from '../../../../../common/react/hooks/use-competition-navigation-options';
import { useNavSync } from './hooks/use-nav-sync';

export const VideoHub = ({ competitionId, seasonId, title }) => {
    const initialValues = { competitionId, seasonId };

    const nav = useSelector(navSelector);
    const options = useCompetitionNavigationOptions(nav);
    useNavSync({ ...options, initialValues });

    const competitions = useSelector((state) => state.competitions.list);

    const seasons = useSelector(
        (state) =>
            state.seasons[`competition_${nav.competition.id}`]?.list ?? []
    );

    return (
        <StatsSection.Main>
            <StatsSection.Heading isSmallModifier={true}>
                {title}
            </StatsSection.Heading>
            <StatsSection.Nav>
                <StatsSection.NavItems>
                    <CompNavItem competitions={competitions} />
                    <SeasonNavItem seasons={seasons} />
                    <RoundListNavItem
                        classes={'video-hub__round-filter-wrapper'}
                    />
                </StatsSection.NavItems>
            </StatsSection.Nav>
        </StatsSection.Main>
    );
};

VideoHub.propTypes = {
    seasonPid: PropTypes.string,
    competitionId: PropTypes.string,
    seasonId: PropTypes.string,
    round: PropTypes.string,
    title: PropTypes.string
};
